export default "__VITE_ASSET__CAJPEjHF__"